// Used for physicians, locations, hospital services where we want to allow
// users to input any value and not restrict them to existing values in the system
// Check on backend why we don't have type, operationType, etc. for this filter
// type like we do for others.

export const formatSimpleFilter = (
  values: Nullable<unknown>,
  propertyName: string
): any => {
  if (!values) return null;

  return {
    propertyName,
    valueObject: values,
  };
};
